import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";
import { Cookies } from "react-cookie";

export const addImages = createAsyncThunk(
  "addImages",
  async ({ id, formData }) => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");
      const response = await AxiosInstance.put(
        `${API_KEY}/api/society/update-media/${id}`,
        formData,
        {
          headers: { Authorization: `Barear ${token}` },
          "Content-Type": "multipart/form-data",
        }
      );

      return response;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      } else {
        throw error;
      }
    }
  }
);

const initialState = {
  isLoading: false,
  addImagesData: null,
  isError: false,
  errorMessage: "",
};
const addImagesSlice = createSlice({
  name: "addImages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(addImages.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addImages.fulfilled, (state, action) => {
      state.isLoading = false;
      state.addImagesData = action.payload;
    });
    builder.addCase(addImages.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default addImagesSlice.reducer;
